<template>
    <div>
        <div class="g-mb-5">
            <a class="image campaign-image is-4by3" @click="$root.showCampaign(campaign.id)">
                <img v-if="campaign.image" :src="campaign.image" :alt="campaign.brand.name" />
            </a>
        </div>
        <div>
            <g-typography class="campaign-title g-mb-2" tag="h2" font-weight="semibold" :value="campaign.title" />
            <g-typography
                v-if="campaign.short_description"
                class="preview-div g-mb-3"
                tag="p"
                color="grey-6"
                :value="campaign.short_description"
            />

            <g-typography v-if="accepted_proposals.length > 0" tag="p" color="grey-6" class="g-mb-3">
                You have {{ accepted_proposals.length }} accepted proposal<span v-if="proposals.length !== 1">s</span>.
            </g-typography>
            <g-typography v-else-if="proposals.length > 0" tag="p" color="grey-6" class="g-mb-3">
                You have submitted {{ proposals.length }} proposal<span v-if="proposals.length !== 1">s</span>.
            </g-typography>

            <div class="g-mb-3 g-mt-5">
                <div v-if="!recurring_proposals">
                    <g-button
                        v-if="!proposals.length"
                        shape="round"
                        theme="live"
                        type="primary"
                        @click="$root.showCampaignApplication(campaign)"
                    >
                        {{ customizationText('get_started_button_text', 'Get Started', campaign) }}
                    </g-button>
                    <div v-else>
                        <router-link
                            v-if="
                                accepted_proposals.length &&
                                campaign.hasOwnProperty('version') &&
                                campaign.version === 2
                            "
                            :to="{
                                name: 'v2.campaign.proposal',
                                params: { campaign_id: campaign.id, proposal_id: accepted_proposals[0].id }
                            }"
                            class="no-underline"
                        >
                            <g-button shape="round" theme="live">View</g-button>
                        </router-link>
                        <g-button
                            v-else-if="accepted_proposals.length"
                            shape="round"
                            theme="live"
                            @click="$root.showJob(accepted_proposals[0].id)"
                        >
                            View
                        </g-button>
                        <g-button v-else shape="round" theme="live" @click="$root.showCampaignProposals(campaign.id)">
                            My Proposal
                        </g-button>
                    </div>
                </div>
                <div v-else>
                    <g-button
                        v-if="!proposals.length"
                        shape="round"
                        theme="live"
                        type="primary"
                        @click="$root.showCampaignApplication(campaign)"
                    >
                        {{ customizationText('get_started_button_text', 'Get Started', campaign) }}
                    </g-button>
                    <div v-else>
                        <g-row type="flex" justify="start" :gutter="[16, 0]" class="proposal-buttons">
                            <g-column>
                                <g-button
                                    v-if="campaign.is_active"
                                    shape="round"
                                    theme="live"
                                    @click="$root.showCampaignApplication(campaign)"
                                >
                                    New Proposal
                                </g-button>
                            </g-column>

                            <g-column>
                                <g-button shape="round" theme="live" @click="$root.showCampaignProposals(campaign.id)">
                                    My Proposals
                                </g-button>
                            </g-column>
                        </g-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CampaignCustomizeMixin from '../../../mixins/CampaignCustomizeMixin';
    export default {
        name: 'CampaignListRow',
        mixins: [CampaignCustomizeMixin],
        props: {
            campaign: {
                type: Object,
                required: true
            }
        },

        /**
         * The computed properties
         */
        computed: {
            /**
             * The proposals for this campaign
             *
             * @returns {array}
             */
            proposals() {
                return this.$root.campaignProposals(this.campaign.id);
            },

            /**
             * The accepted proposals
             *
             * @returns {array}
             */
            accepted_proposals() {
                return this.proposals.filter((proposal) => proposal.accepted_at);
            },

            /**
             * Whether the campaign allows recurring proposals
             *
             * @returns {boolean}
             */
            recurring_proposals() {
                return this.campaign.proposal_interval === 1;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .campaign-image {
        img {
            border-radius: $g-border-radius-lg;
        }
    }

    .break-new-line {
        white-space: pre-line;
    }

    .preview-div {
        max-height: 60px;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }

    @media only screen and (max-width: $g-screen-size-xs) {
        button {
            width: 100%;
        }

        .proposal-buttons {
            justify-content: space-around;

            .ant-col {
                width: 50%;
            }
        }
    }
</style>
